import type { FC } from 'react';

export interface ClubStoreLayoutProps {
  pageTitle: React.ReactNode;
  clubCoin: React.ReactNode;
  navigation: React.ReactNode;

  content: React.ReactNode;
}

export const ClubStoreLayout: FC<ClubStoreLayoutProps> = ({
  pageTitle,
  clubCoin,
  navigation,
  content,
}) => {
  return (
    <div className="font-poppins pb-20">
      <div className="mb-4 flex items-center justify-between">
        <div className="text-text300 text-base font-semibold md:text-xl">
          {pageTitle}
        </div>
        {clubCoin}
      </div>
      {navigation}
      <div className="mt-2 flex flex-col gap-y-6">{content}</div>
    </div>
  );
};
